module.exports = __webpack_public_path__ + "static/media/Skin_tone_3.7d68db8e.svg";